import {
  type ParsedResponse as _ParsedResponse,
  ResourceFor as _ResourceFor,
  ResponsesFor as _ResponsesFor,
  SchemasFor as _SchemasFor,
} from '@execonline-inc/resourceable.private';
import Resourceable from './Init';
import Schema from './Schema';

export { Schema };

export const { fetch } = Resourceable;

export type EndpointSchemas = typeof Schema.endpoints;
export type Endpoint = keyof EndpointSchemas;
type S = EndpointSchemas;

type SchemasFor<E extends keyof S, M extends keyof S[E]> = _SchemasFor<S, E, M>;

export type ResponsesFor<E extends keyof S, M extends keyof S[E]> = _ResponsesFor<S, E, M>;

export type ParsedResponse<E extends keyof S, M extends keyof S[E]> = _ParsedResponse<S, E, M>;

export type ResourceFor<
  E extends keyof S,
  M extends keyof S[E],
  C extends keyof SchemasFor<E, M>,
> = _ResourceFor<S, E, M, C>;
